module.exports = __webpack_public_path__ + "img/Graphics-1.cde890b3.svg";